import React, {useEffect, useState} from 'react';
import {Label} from '../../pages/about/register';
import {Button, DatePicker, Input, Radio, Select, Tooltip} from 'antd';
import {useInput} from 'react-hanger';
import moment, {Moment} from 'moment';
import Text from 'antd/lib/typography/Text';
import {SpecialtyCommitteeList} from '../../utils/CommitteeList';
import UploadImage from '../UploadImage';
import TextArea from 'antd/lib/input/TextArea';
import {PersonalApprove, SavePersonalApproveParams} from '../../scaffold';

export default function PersonalApproveTable(props: {
  readonly?: boolean;
  onSubmit?: (p: SavePersonalApproveParams) => any;
  loading?: boolean;
  approve?: PersonalApprove;
}) {
  const name = useInput('');
  const nationality = useInput('');
  const identificationCardNo = useInput('');
  const gender = useInput('男');

  const [birthDate, _birthDate] = useState<Moment>();
  const party = useInput('');
  const nativePlace = useInput('');
  const email = useInput('');

  const avatarPath = useInput('');

  const organizationFullTime = useInput('');
  const organizationDepartmentFullTime = useInput('');
  const positionFullTime = useInput('');
  const levelFullTime = useInput('');

  const organizationPartTime = useInput('');
  const organizationDepartmentPartTime = useInput('');
  const positionPartTime = useInput('');
  const levelPartTime = useInput('');

  const schoolDomestic = useInput('');
  const schoolDepartmentDomestic = useInput('');
  const schoolDateRangeDomestic = useInput('');
  const graduationDomestic = useInput('');
  const degreeDomestic = useInput('');

  const schoolAboard = useInput('');
  const schoolDepartmentAboard = useInput('');
  const schoolDateRangeAboard = useInput('');
  const graduationAboard = useInput('');
  const degreeAboard = useInput('');

  const schoolAmateur = useInput('');
  const schoolDepartmentAmateur = useInput('');
  const schoolDateRangeAmateur = useInput('');
  const graduationAmateur = useInput('');
  const degreeAmateur = useInput('');

  const organizationUndergo01 = useInput('');
  const positionUndergo01 = useInput('');
  const dateRangeUndergo01 = useInput('');
  const locationUndergo01 = useInput('');

  const organizationUndergo02 = useInput('');
  const positionUndergo02 = useInput('');
  const dateRangeUndergo02 = useInput('');
  const locationUndergo02 = useInput('');

  const organizationUndergo03 = useInput('');
  const positionUndergo03 = useInput('');
  const dateRangeUndergo03 = useInput('');
  const locationUndergo03 = useInput('');

  const organizationAddress01 = useInput('');
  const organizationTel01 = useInput('');
  const organizationPostcode01 = useInput('');

  const organizationAddress02 = useInput('');
  const organizationTel02 = useInput('');
  const organizationPostcode02 = useInput('');

  const massOrganizationPosition = useInput('');
  const techOrganizationPosition = useInput('');
  const foreignLanguageLevel = useInput('');

  const specialty = useInput('');

  const mainSpecialCommittee = useInput('');
  const subSpecialCommittee01 = useInput('');
  const subSpecialCommittee02 = useInput('');

  const currentDegree = useInput('');
  const currentSchool = useInput('');
  const currentTeacher = useInput('');

  const studentImagePath = useInput('');
  const remark = useInput('');

  useEffect(() => {
    if (props.approve) {
      name.setValue(props.approve?.name || '');
      nationality.setValue(props.approve?.nationality || '');
      identificationCardNo.setValue(props.approve?.identificationCardNo || '');
      gender.setValue(props.approve?.gender || '男');
      _birthDate(moment(props.approve?.birthDate ?? '1900-01-01'));
      party.setValue(props.approve?.party || '');
      nativePlace.setValue(props.approve?.nativePlace || '');
      email.setValue(props.approve?.email || '');

      avatarPath.setValue(props.approve?.avatarPath || '');

      organizationFullTime.setValue(props.approve?.organizationFullTime || '');
      organizationDepartmentFullTime.setValue(props.approve?.organizationDepartmentFullTime || '');
      positionFullTime.setValue(props.approve?.positionFullTime || '');
      levelFullTime.setValue(props.approve?.levelFullTime || '');

      organizationPartTime.setValue(props.approve?.organizationPartTime || '');
      organizationDepartmentPartTime.setValue(props.approve?.organizationDepartmentPartTime || '');
      positionPartTime.setValue(props.approve?.positionPartTime || '');
      levelPartTime.setValue(props.approve?.levelPartTime || '');

      schoolDomestic.setValue(props.approve?.schoolDomestic || '');
      schoolDepartmentDomestic.setValue(props.approve?.schoolDepartmentDomestic || '');
      schoolDateRangeDomestic.setValue(props.approve?.schoolDateRangeDomestic || '');
      graduationDomestic.setValue(props.approve?.graduationDomestic || '');
      degreeDomestic.setValue(props.approve?.degreeDomestic || '');

      schoolAboard.setValue(props.approve?.schoolAboard || '');
      schoolDepartmentAboard.setValue(props.approve?.schoolDepartmentAboard || '');
      schoolDateRangeAboard.setValue(props.approve?.schoolDateRangeAboard || '');
      graduationAboard.setValue(props.approve?.graduationAboard || '');
      degreeAboard.setValue(props.approve?.degreeAboard || '');

      schoolAmateur.setValue(props.approve?.schoolAmateur || '');
      schoolDepartmentAmateur.setValue(props.approve?.schoolDepartmentAmateur || '');
      schoolDateRangeAmateur.setValue(props.approve?.schoolDateRangeAmateur || '');
      graduationAmateur.setValue(props.approve?.graduationAmateur || '');
      degreeAmateur.setValue(props.approve?.degreeAmateur || '');

      organizationUndergo01.setValue(props.approve?.organizationUndergo01 || '');
      positionUndergo01.setValue(props.approve?.positionUndergo01 || '');
      dateRangeUndergo01.setValue(props.approve?.dateRangeUndergo01 || '');
      locationUndergo01.setValue(props.approve?.locationUndergo01 || '');

      organizationUndergo02.setValue(props.approve?.organizationUndergo02 || '');
      positionUndergo02.setValue(props.approve?.positionUndergo02 || '');
      dateRangeUndergo02.setValue(props.approve?.dateRangeUndergo02 || '');
      locationUndergo02.setValue(props.approve?.locationUndergo02 || '');

      organizationUndergo03.setValue(props.approve?.organizationUndergo03 || '');
      positionUndergo03.setValue(props.approve?.positionUndergo03 || '');
      dateRangeUndergo03.setValue(props.approve?.dateRangeUndergo03 || '');
      locationUndergo03.setValue(props.approve?.locationUndergo03 || '');

      organizationAddress01.setValue(props.approve?.organizationAddress01 || '');
      organizationTel01.setValue(props.approve?.organizationTel01 || '');
      organizationPostcode01.setValue(props.approve?.organizationPostcode01 || '');

      organizationAddress02.setValue(props.approve?.organizationAddress02 || '');
      organizationTel02.setValue(props.approve?.organizationTel02 || '');
      organizationPostcode02.setValue(props.approve?.organizationPostcode02 || '');

      massOrganizationPosition.setValue(props.approve?.massOrganizationPosition || '');
      techOrganizationPosition.setValue(props.approve?.techOrganizationPosition || '');
      foreignLanguageLevel.setValue(props.approve?.foreignLanguageLevel || '');

      specialty.setValue(props.approve?.specialty || '');

      mainSpecialCommittee.setValue(props.approve?.mainSpecialCommittee || '');
      subSpecialCommittee01.setValue(props.approve?.subSpecialCommittee01 || '');
      subSpecialCommittee02.setValue(props.approve?.subSpecialCommittee02 || '');

      currentDegree.setValue(props.approve?.currentDegree || '');
      currentSchool.setValue(props.approve?.currentSchool || '');
      currentTeacher.setValue(props.approve?.currentTeacher || '');

      studentImagePath.setValue(props.approve?.studentImagePath || '');
      remark.setValue(props.approve?.remark || '');
    } else {
      name.clear();
      nationality.clear();
      identificationCardNo.clear();
      gender.setValue('男');

      _birthDate(undefined);
      party.clear();
      nationality.clear();
      email.clear();

      avatarPath.clear();

      organizationFullTime.clear();
      organizationDepartmentFullTime.clear();
      positionFullTime.clear();
      levelFullTime.clear();

      organizationPartTime.clear();
      organizationDepartmentPartTime.clear();
      positionPartTime.clear();
      levelPartTime.clear();

      schoolDomestic.clear();
      schoolDepartmentDomestic.clear();
      schoolDateRangeDomestic.clear();
      graduationDomestic.clear();
      degreeDomestic.clear();

      schoolAboard.clear();
      schoolDepartmentAboard.clear();
      schoolDateRangeAboard.clear();
      graduationAboard.clear();
      degreeAboard.clear();

      schoolAmateur.clear();
      schoolDepartmentAmateur.clear();
      schoolDateRangeAmateur.clear();
      graduationAmateur.clear();
      degreeAmateur.clear();

      organizationUndergo01.clear();
      positionUndergo01.clear();
      dateRangeUndergo01.clear();
      locationUndergo01.clear();

      organizationUndergo02.clear();
      positionUndergo02.clear();
      dateRangeUndergo02.clear();
      locationUndergo02.clear();

      organizationUndergo03.clear();
      positionUndergo03.clear();
      dateRangeUndergo03.clear();
      locationUndergo03.clear();

      organizationAddress01.clear();
      organizationTel01.clear();
      organizationPostcode01.clear();

      organizationAddress02.clear();
      organizationTel02.clear();
      organizationPostcode02.clear();

      massOrganizationPosition.clear();
      techOrganizationPosition.clear();
      foreignLanguageLevel.clear();

      specialty.clear();

      mainSpecialCommittee.clear();
      subSpecialCommittee01.clear();
      subSpecialCommittee02.clear();

      currentDegree.clear();
      currentSchool.clear();
      currentTeacher.clear();

      studentImagePath.clear();
      remark.clear();
    }
  }, [props.approve]);

  function submit() {
    props.onSubmit &&
      props.onSubmit({
        userId: 0,

        name: name.value,
        nationality: nationality.value,
        identificationCardNo: identificationCardNo.value,
        gender: gender.value,

        birthDate: birthDate?.format('YYYY-MM-DD'),
        party: party.value,
        nativePlace: nativePlace.value,
        email: email.value,

        avatarPath: avatarPath.value,

        organizationFullTime: organizationFullTime.value,
        organizationDepartmentFullTime: organizationDepartmentFullTime.value,
        positionFullTime: positionFullTime.value,
        levelFullTime: levelFullTime.value,

        organizationPartTime: organizationPartTime.value,
        organizationDepartmentPartTime: organizationDepartmentPartTime.value,
        positionPartTime: positionPartTime.value,
        levelPartTime: levelPartTime.value,

        schoolDomestic: schoolDomestic.value,
        schoolDepartmentDomestic: schoolDepartmentDomestic.value,
        schoolDateRangeDomestic: schoolDateRangeDomestic.value,
        graduationDomestic: graduationDomestic.value,
        degreeDomestic: degreeDomestic.value,

        schoolAboard: schoolAboard.value,
        schoolDepartmentAboard: schoolDepartmentAboard.value,
        schoolDateRangeAboard: schoolDateRangeAboard.value,
        graduationAboard: graduationAboard.value,
        degreeAboard: degreeAboard.value,

        schoolAmateur: schoolAmateur.value,
        schoolDepartmentAmateur: schoolDepartmentAmateur.value,
        schoolDateRangeAmateur: schoolDateRangeAmateur.value,
        graduationAmateur: graduationAmateur.value,
        degreeAmateur: degreeAmateur.value,

        organizationUndergo01: organizationUndergo01.value,
        positionUndergo01: positionUndergo01.value,
        dateRangeUndergo01: dateRangeUndergo01.value,
        locationUndergo01: locationUndergo01.value,

        organizationUndergo02: organizationUndergo02.value,
        positionUndergo02: positionUndergo02.value,
        dateRangeUndergo02: dateRangeUndergo02.value,
        locationUndergo02: locationUndergo02.value,

        organizationUndergo03: organizationUndergo03.value,
        positionUndergo03: positionUndergo03.value,
        dateRangeUndergo03: dateRangeUndergo03.value,
        locationUndergo03: locationUndergo03.value,

        organizationAddress01: organizationAddress01.value,
        organizationTel01: organizationTel01.value,
        organizationPostcode01: organizationPostcode01.value,

        organizationAddress02: organizationAddress02.value,
        organizationTel02: organizationTel02.value,
        organizationPostcode02: organizationPostcode02.value,

        massOrganizationPosition: massOrganizationPosition.value,
        techOrganizationPosition: techOrganizationPosition.value,
        foreignLanguageLevel: foreignLanguageLevel.value,

        specialty: specialty.value,

        mainSpecialCommittee: mainSpecialCommittee.value,
        subSpecialCommittee01: subSpecialCommittee01.value,
        subSpecialCommittee02: subSpecialCommittee02.value,

        currentDegree: currentDegree.value,
        currentSchool: currentSchool.value,
        currentTeacher: currentTeacher.value,

        studentImagePath: studentImagePath.value,
        remark: remark.value,
      });
  }

  const graduationOptions = [{value: '', label: '请选择', disabled: true}, {value: '毕业'}, {value: '肄业'}];
  const degreeOptions = [{value: '', label: '请选择', disabled: true}, {value: '学士'}, {value: '硕士'}, {value: '博士'}, {value: '博士后'}, {value: '其它'}];
  const committeeOptions = [{value: '', label: '请选择', disabled: true}, ...SpecialtyCommitteeList.map(i => ({value: i}))];
  const partyOptions = [
    {value: '', label: '请选择', disabled: true},
    {value: '中国共产党'},
    {value: '中国国民党革命委员会'},
    {value: '中国民主同盟'},
    {value: '中国民主建国会'},
    {value: '中国民主促进会'},
    {value: '中国农工民主党'},
    {value: '中国致公党'},
    {value: '九三学社'},
    {value: '台湾民主自治同盟'},
    {value: '群众'},
    {value: '其他'},
  ];

  return (
    <table className={'RegisterTable'}>
      <tbody>
        <tr>
          <td>
            <Label required>姓名</Label>
          </td>
          <td colSpan={2}>
            <Input disabled={props.readonly} {...name.eventBind} />
          </td>
          <td>
            <Label required>民族</Label>
          </td>
          <td colSpan={2}>
            <Input disabled={props.readonly} {...nationality.eventBind} />
          </td>
          <td rowSpan={4}>
            <UploadImage {...avatarPath.valueBind} label={'上传头像照'} readOnly={props.readonly} />
          </td>
        </tr>
        <tr>
          <td>
            <Label required>身份证号</Label>
          </td>
          <td colSpan={2}>
            <Input disabled={props.readonly} {...identificationCardNo.eventBind} />
          </td>
          <td>
            <Label>性别</Label>
          </td>
          <td colSpan={2}>
            <Radio.Group value={gender.value} onChange={e => gender.setValue(e.target.value)} disabled={props.readonly}>
              <Radio value={'男'}>男</Radio>
              <Radio value={'女'}>女</Radio>
            </Radio.Group>
          </td>
        </tr>
        <tr>
          <td>
            <Label>出生年月</Label>
          </td>
          <td colSpan={2}>
            <DatePicker value={birthDate} onChange={e => _birthDate(e as Moment)} disabled={props.readonly} style={{width: '100%'}} />
          </td>
          <td>
            <Label required>参加党派</Label>
          </td>
          <td colSpan={2}>
            <Select placeholder={'请选择'} {...party.valueBind} options={partyOptions} style={{width: '100%'}} disabled={props.readonly} />
          </td>
        </tr>
        <tr>
          <td>
            <Label>籍贯</Label>
          </td>
          <td colSpan={2}>
            <Input disabled={props.readonly} {...nativePlace.eventBind} />
          </td>
          <td>
            <Label required>E-mail</Label>
          </td>
          <td colSpan={2}>
            <Input disabled={props.readonly} {...email.eventBind} />
          </td>
        </tr>
        <tr>
          <td rowSpan={3}>现任工作</td>
          <td />
          <td>
            单位名称 <br />
            （全称）
          </td>
          <td>
            部门 <br />
            （院系名称）
          </td>
          <td>职务</td>
          <td colSpan={2}>技术职称和级别</td>
        </tr>
        <tr>
          <td>
            <Label required>专职</Label>
          </td>
          <td>
            <Input {...organizationFullTime.eventBind} disabled={props.readonly} />
          </td>
          <td>
            <Input {...organizationDepartmentFullTime.eventBind} disabled={props.readonly} />
          </td>
          <td>
            <Input {...positionFullTime.eventBind} disabled={props.readonly} />
          </td>
          <td colSpan={2}>
            <Input {...levelFullTime.eventBind} disabled={props.readonly} />
          </td>
        </tr>
        <tr>
          <td>
            <Label>兼职</Label>
          </td>
          <td>
            <Input {...organizationPartTime.eventBind} disabled={props.readonly} />
          </td>
          <td>
            <Input {...organizationDepartmentPartTime.eventBind} disabled={props.readonly} />
          </td>
          <td>
            <Input {...positionPartTime.eventBind} disabled={props.readonly} />
          </td>
          <td colSpan={2}>
            <Input {...levelPartTime.eventBind} disabled={props.readonly} />
          </td>
        </tr>
        <tr>
          <td width={110} rowSpan={4}>
            最后学历
          </td>
          <td width={70} />
          <td>学校名称</td>
          <td width={130}>科系</td>
          <td width={130}>起讫年月</td>
          <td width={130}>毕业或肄业</td>
          <td width={130}>学位</td>
        </tr>
        <tr>
          <td>
            <Label required>国内</Label>
          </td>
          <td>
            <Input {...schoolDomestic.eventBind} disabled={props.readonly} />
          </td>
          <td>
            <Input {...schoolDepartmentDomestic.eventBind} disabled={props.readonly} />
          </td>
          <td>
            <Tooltip title={'例 2016-01~2017-09'}>
              <Input {...schoolDateRangeDomestic.eventBind} disabled={props.readonly} />
            </Tooltip>
          </td>
          <td>
            <Select placeholder={'请选择'} {...graduationDomestic.valueBind} options={graduationOptions} style={{width: '100%'}} disabled={props.readonly} />
          </td>
          <td>
            <Select placeholder={'请选择'} {...degreeDomestic.valueBind} options={degreeOptions} style={{width: '100%'}} disabled={props.readonly} />
          </td>
        </tr>
        <tr>
          <td>
            <Label>国外</Label>
          </td>
          <td>
            <Input {...schoolAboard.eventBind} disabled={props.readonly} />
          </td>
          <td>
            <Input {...schoolDepartmentAboard.eventBind} disabled={props.readonly} />
          </td>
          <td>
            <Tooltip title={'例 2016-01~2017-09'}>
              <Input {...schoolDateRangeAboard.eventBind} disabled={props.readonly} />
            </Tooltip>
          </td>
          <td>
            <Select placeholder={'请选择'} {...graduationAboard.valueBind} options={graduationOptions} style={{width: '100%'}} disabled={props.readonly} />
          </td>
          <td>
            <Select placeholder={'请选择'} {...degreeAboard.valueBind} options={degreeOptions} style={{width: '100%'}} disabled={props.readonly} />
          </td>
        </tr>
        <tr>
          <td>
            <Label>业余</Label>
          </td>
          <td>
            <Input {...schoolAmateur.eventBind} disabled={props.readonly} />
          </td>
          <td>
            <Input {...schoolDepartmentAmateur.eventBind} disabled={props.readonly} />
          </td>
          <td>
            <Tooltip title={'例 2016-01~2017-09'}>
              <Input {...schoolDateRangeAmateur.eventBind} disabled={props.readonly} />
            </Tooltip>
          </td>
          <td>
            <Select placeholder={'请选择'} {...graduationAmateur.valueBind} options={graduationOptions} style={{width: '100%'}} disabled={props.readonly} />
          </td>
          <td>
            <Select placeholder={'请选择'} {...degreeAmateur.valueBind} options={degreeOptions} style={{width: '100%'}} disabled={props.readonly} />
          </td>
        </tr>
        <tr>
          <td rowSpan={4}>主要经历</td>
          <td colSpan={2}>单位名称</td>
          <td>职称</td>
          <td>起讫年月</td>
          <td colSpan={2}>地点</td>
        </tr>
        <tr>
          <td colSpan={2}>
            <Input {...organizationUndergo01.eventBind} disabled={props.readonly} />
          </td>
          <td>
            <Input {...positionUndergo01.eventBind} disabled={props.readonly} />
          </td>
          <td>
            <Tooltip title={'例 2016-01~2017-09'}>
              <Input {...dateRangeUndergo01.eventBind} disabled={props.readonly} />
            </Tooltip>
          </td>
          <td colSpan={2}>
            <Input {...locationUndergo01.eventBind} disabled={props.readonly} />
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <Input {...organizationUndergo02.eventBind} disabled={props.readonly} />
          </td>
          <td>
            <Input {...positionUndergo02.eventBind} disabled={props.readonly} />
          </td>
          <td>
            <Tooltip title={'例 2016-01~2017-09'}>
              <Input {...dateRangeUndergo02.eventBind} disabled={props.readonly} />
            </Tooltip>
          </td>
          <td colSpan={2}>
            <Input {...locationUndergo02.eventBind} disabled={props.readonly} />
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <Input {...organizationUndergo03.eventBind} disabled={props.readonly} />
          </td>
          <td>
            <Input {...positionUndergo03.eventBind} disabled={props.readonly} />
          </td>
          <td>
            <Tooltip title={'例 2016-01~2017-09'}>
              <Input {...dateRangeUndergo03.eventBind} disabled={props.readonly} />
            </Tooltip>
          </td>
          <td colSpan={2}>
            <Input {...locationUndergo03.eventBind} disabled={props.readonly} />
          </td>
        </tr>
        <tr>
          <td rowSpan={2}>通讯方式</td>
          <td>
            单位 <br />
            地址
          </td>
          <td>
            <Input {...organizationAddress01.eventBind} disabled={props.readonly} />
          </td>
          <td>电话</td>
          <td>
            <Input {...organizationTel01.eventBind} disabled={props.readonly} />
          </td>
          <td>邮编</td>
          <td>
            <Input {...organizationPostcode01.eventBind} disabled={props.readonly} />
          </td>
        </tr>
        <tr>
          <td>
            单位 <br />
            地址
          </td>
          <td>
            <Input {...organizationAddress02.eventBind} disabled={props.readonly} />
          </td>
          <td>电话</td>
          <td>
            <Input {...organizationTel02.eventBind} disabled={props.readonly} />
          </td>
          <td>邮编</td>
          <td>
            <Input {...organizationPostcode02.eventBind} disabled={props.readonly} />
          </td>
        </tr>
        <tr>
          <td colSpan={3}>担任最近一届人代会、政协、其他人民团体职务</td>
          <td colSpan={4}>
            <Input {...massOrganizationPosition.eventBind} disabled={props.readonly} />
          </td>
        </tr>
        <tr>
          <td colSpan={3}>担任各级科技群众团体职务</td>
          <td colSpan={4}>
            <Input {...techOrganizationPosition.eventBind} disabled={props.readonly} />
          </td>
        </tr>
        <tr>
          <td colSpan={3}>懂何外文及熟练程度</td>
          <td colSpan={4}>
            <Input {...foreignLanguageLevel.eventBind} disabled={props.readonly} />
          </td>
        </tr>
        <tr>
          <td colSpan={2}>专长</td>
          <td colSpan={5}>
            <Input {...specialty.eventBind} disabled={props.readonly} />
          </td>
        </tr>
        <tr>
          <td colSpan={2} rowSpan={2}>
            <Label required>
              <div>
                希望加入何专委会 <br />
                （可多选）
              </div>
            </Label>
          </td>
          <td colSpan={5}>
            <Text type={'secondary'}>请至少选取一个您感兴趣的专委会，您的个人会员档案将落在第一选择的专委会中</Text>
          </td>
        </tr>
        <tr>
          <td>
            <Select
              placeholder={'请选择'}
              {...mainSpecialCommittee.valueBind}
              options={committeeOptions}
              style={{width: '100%'}}
              allowClear
              disabled={props.readonly}
            />
          </td>
          <td colSpan={2}>
            <Select
              placeholder={'请选择'}
              {...subSpecialCommittee01.valueBind}
              options={committeeOptions}
              style={{width: '100%'}}
              allowClear
              disabled={props.readonly}
            />
          </td>
          <td colSpan={2}>
            <Select
              placeholder={'请选择'}
              {...subSpecialCommittee02.valueBind}
              options={committeeOptions}
              style={{width: '100%'}}
              allowClear
              disabled={props.readonly}
            />
          </td>
        </tr>
        <tr>
          <td colSpan={2} rowSpan={2}>
            <Label>
              <div>仅限学生会员填写</div>
            </Label>
          </td>
          <td>在读学历</td>
          <td colSpan={2}>在读院校</td>
          <td colSpan={2}>导师姓名</td>
        </tr>
        <tr>
          <td>
            <Input {...currentDegree.eventBind} disabled={props.readonly} />
          </td>
          <td colSpan={2}>
            <Input {...currentSchool.eventBind} disabled={props.readonly} />
          </td>
          <td colSpan={2}>
            <Input {...currentTeacher.eventBind} disabled={props.readonly} />
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <Label>
              <div>上传学生证照片</div>
            </Label>
          </td>
          <td colSpan={5}>
            <UploadImage {...studentImagePath.valueBind} readOnly={props.readonly} />
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <Label>
              <div>备注</div>
            </Label>
          </td>
          <td colSpan={5}>
            <TextArea {...remark.eventBind} rows={4} disabled={props.readonly} />
          </td>
        </tr>
        {!props.readonly && (
          <tr>
            <td colSpan={7}>
              <Button type={'primary'} onClick={submit} loading={props.loading}>
                提交
              </Button>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
}
